import React from 'react';
import styled from 'styled-components';

interface HorizontalDividerProps {
  text?: string;
  color?: string;
  textColor?: string;
  fontSize?: string;
}

const DividerContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin: 24px 0;
`;

const DividerLine = styled.div<{ $color: string }>`
  flex: 1;
  height: 1px;
  background-color: ${props => props.$color};
`;

const DividerText = styled.span<{ $textColor: string; $fontSize: string }>`
  margin: 0 16px;
  color: ${props => props.$textColor};
  font-size: ${props => props.$fontSize};
  white-space: nowrap;
`;

const HorizontalDivider: React.FC<HorizontalDividerProps> = ({ 
  text, 
  color = '#cccccc', 
  textColor = '#666', 
  fontSize = '14px' 
}) => {
  if (text) {
    return (
      <DividerContainer>
        <DividerLine $color={color} />
        <DividerText $textColor={textColor} $fontSize={fontSize}>
          {text}
        </DividerText>
        <DividerLine $color={color} />
      </DividerContainer>
    );
  }

  return (
    <DividerContainer>
      <DividerLine $color={color} />
    </DividerContainer>
  );
};

export default HorizontalDivider;
